"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrc = void 0;
var easyCrc_sidecar_1 = require("@dive/to-engine/easyCrc-sidecar");
var diveSimulationManager_sidecar_1 = require("./diveSimulationManager-sidecar");
function getCrc() {
    var _a = easyCrc_sidecar_1.easyCrc.create('misc'), add = _a.add, getCrc = _a.getCrc;
    add(diveSimulationManager_sidecar_1.diveSimulationManager.get().synced_idCounter);
    // Unimportant rando can be desynced
    // add(diveSimulationManager.get().syncedUnimportantRando.getCurrentSeed())
    // TODO: this is out of sync
    console.log('syncedImportantRando current seed', diveSimulationManager_sidecar_1.diveSimulationManager.get().syncedImportantRando.getCurrentSeed());
    add(diveSimulationManager_sidecar_1.diveSimulationManager.get().syncedImportantRando.getCurrentSeed());
    return getCrc();
}
exports.getCrc = getCrc;
